// extracted by mini-css-extract-plugin
export default {"StripeElement":"PaymentModal_StripeElement__-ah+X","toc":"PaymentModal_toc__lX+vR","apply":"PaymentModal_apply__mwQ0k","dialog":"PaymentModal_dialog__4zbGW"};